import React, { useState } from "react";
import KeyboardManager from "./KeyboardManager";
import BeadViewer from "./BeadViewer";
import Checkout from "./Checkout";
import IntroPopup from "./IntroPopup";

const BeadStateManager = () => {

    const [beads, setBeads] = useState('');

    return (
        <div className="container">
            <div className="headerRow">
                <h1 className="title">🅣🅐🅟 🅑🅔🅐🅓🅢</h1>
                <IntroPopup />
            </div>
            <div className="content-scroll">
                <BeadViewer
                    beads={beads}
                />
            </div>


            <div className="bottom-container">
                <Checkout beads={beads}/>
                <KeyboardManager
                    getInput={setBeads}
                />
            </div>
        </div>
    );

};

export default BeadStateManager; 